import loadable from '@loadable/component';

// 懒加载组件
const SupplyCommodityManagement = loadable(() => import('./supplyCommodityManagement/SupplyCommodityManagement'));

export const subRoutes = [
  {
    // 药品供货关系管理
    path: '/SupplyCommodityManagement',
    component: SupplyCommodityManagement
  }
];
